import {
  Container,
  Title,
  Text,
  Button,
  Center,
  SimpleGrid,
  Space,
} from "@mantine/core";
import classes from "./CTABanner.module.css";
import academy from "../../media/AcademySite.gif";
import { Trans } from "react-i18next";
import { useCart } from "../Cart/CartContext";

export function CTABanner() {
  const { openCart } = useCart();
  return (
    <Center>
      <SimpleGrid cols={{ base: 1, xs: 2 }} spacing={250} verticalSpacing={60}>
        <Center>
          <Container className={classes.wrapper}>
            <Title className={classes.title}>
              <Text
                fs="italic"
                fw={900}
                inherit
                variant="gradient"
                gradient={{ from: "yellow", to: "#FEBF0E" }}
              >
                <Trans i18nKey="cta.main.title" />
              </Text>
            </Title>
            <Text size="xl" fw={500}>
              <Trans i18nKey="cta.main.costs" />
            </Text>
            <Text size="sm">
              <Trans i18nKey="cta.main.changeLinkedAccount_1" />
            </Text>
            <Text size="sm">
              <Trans i18nKey="cta.main.changeLinkedAccount_2" />
            </Text>
            <Space h={"lg"} />
            <Button color={"#FEBF0E"} fullWidth onClick={openCart}>
              <Text c="#3F3722">
                <Trans i18nKey="cta.main.checkout" />
              </Text>
            </Button>
          </Container>
        </Center>
        <Center>
          <img alt="gif of the academy functionality showcase" className={classes.academyGif} src={academy} />
        </Center>
      </SimpleGrid>
    </Center>
  );
}
